__turbopack_context__.v({
  "container": "KeyFeatures-module-scss-module__dBGw2a__container",
  "content": "KeyFeatures-module-scss-module__dBGw2a__content",
  "download": "KeyFeatures-module-scss-module__dBGw2a__download",
  "downloadMobile": "KeyFeatures-module-scss-module__dBGw2a__downloadMobile",
  "feature": "KeyFeatures-module-scss-module__dBGw2a__feature",
  "grid": "KeyFeatures-module-scss-module__dBGw2a__grid",
  "header": "KeyFeatures-module-scss-module__dBGw2a__header",
  "headerRight": "KeyFeatures-module-scss-module__dBGw2a__headerRight",
  "heading": "KeyFeatures-module-scss-module__dBGw2a__heading",
  "headingAccent": "KeyFeatures-module-scss-module__dBGw2a__headingAccent",
  "icon": "KeyFeatures-module-scss-module__dBGw2a__icon",
  "iconContainer": "KeyFeatures-module-scss-module__dBGw2a__iconContainer",
  "iconWrapper": "KeyFeatures-module-scss-module__dBGw2a__iconWrapper",
  "infoButton": "KeyFeatures-module-scss-module__dBGw2a__infoButton",
  "label": "KeyFeatures-module-scss-module__dBGw2a__label",
  "section": "KeyFeatures-module-scss-module__dBGw2a__section",
  "swatch": "KeyFeatures-module-scss-module__dBGw2a__swatch",
  "swissMade": "KeyFeatures-module-scss-module__dBGw2a__swissMade",
  "tooltip": "KeyFeatures-module-scss-module__dBGw2a__tooltip",
  "value": "KeyFeatures-module-scss-module__dBGw2a__value",
});
